module.exports = __webpack_public_path__ + "img/service-9.63ed9689.jpg";